import { useAuth } from "react-oidc-context";
import { useConfig } from "../lib/use-config";

export function LoginPage({ error, from }: { error?: string; from: string }) {
  const auth = useAuth();
  const cfg = useConfig();
  const google = cfg.googleEnabled === "true";
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center px-8 safe-top safe-bottom">
      <div className="text-5xl mb-4">🎙️</div>
      <h1 className="text-2xl font-bold mb-2">회의록 분석</h1>
      <p className="text-slate-400 text-center text-sm mb-8">회의 녹음(mp3)을 올리면 전사·화자 분리·요약·F/U·AI 제안을 만들어 드립니다.</p>
      <button
        className="tap w-full max-w-xs rounded-xl bg-white text-slate-900 font-semibold py-3 active:scale-[0.98]"
        onClick={() => void auth.signinRedirect({ state: { from } })}
      >
        {google ? "Google 계정으로 로그인" : "로그인"}
      </button>
      {error && <p className="mt-4 text-sm text-red-300 text-center">{error}</p>}
      <p className="mt-6 text-xs text-slate-500 text-center">허용된 계정만 로그인할 수 있습니다.</p>
    </div>
  );
}
